export enum SubscribeEvent {
  SHOW_SEARCH_SHEET = 'ShowSearchSheet',
  Follow_Token = 'FollowToken',
  Follow_Wallet = 'FollowWallet',
  Sign_Expired = 'SignExpired',
  Login_Status = 'LoginStatus',
  Update_Realtime_Price = 'UpdateRealtimePrice',
  Open_Wallet_Modal = 'OpenWalletModal',
  Open_Order_Type_Modal = 'OpenOrderTypeModal',
  Update_Pump_Create = 'UpdatePumpCreate',
  Update_Balance = 'UpdateBalance',
  Update_Order = 'UpdateOrder',
  Update_Signal = 'UpdateSignal',
  Update_Signal_Price = 'UpdateSignalPrice',
  Update_Signal_Liquidity = 'UpdateSignalLiquidity',
  Update_Signal_Holders = 'UpdateSignalHolders',
  Update_Profit = 'UpdateProfit',
  Update_Token_Info = 'UpdateTokenInfo',
  Focus_Token = 'FocusToken',
  Refresh_Holding = 'RefreshHolding',
}
